import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../../data/welding';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-mist py-14 text-ink sm:py-20" aria-labelledby="faq-title" data-id="element-158" data-mp="zryod3tacksf">
      <div className="mx-auto grid w-full max-w-6xl gap-6 px-5 sm:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-159" data-mp="urko47xxef4y">
        <div className="lg:col-span-4" data-id="element-160" data-mp="73ayeuxld78j">
          <h2 id="faq-title" className="font-heading text-[2.05rem] font-bold uppercase leading-[0.98] text-ink sm:text-[2.8rem]" data-id="element-161" data-mp="22n8kcl3mwfw">
            QUESTIONS BEFORE YOU START?
          </h2>
        </div>

        <ul className="divide-y divide-ink/10 border-y border-ink/10 lg:col-span-8" data-id="element-162" data-mp="bzi3kli5yepf">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-163" data-mp="1neoou0pzk7ax" data-mpi={index}>
                <h3 data-id="element-164" data-mp="1nht0tk9p07c5">
                  <button type="button" id={`faq-trigger-${index}`} onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex min-h-[64px] w-full items-center justify-between gap-4 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-arc/40" data-id="element-165" data-mp="htzfy4k4zxqs">
                    <span className="text-[1.02rem] font-semibold leading-snug text-ink sm:text-[1.08rem]" data-id="element-166" data-mp="3v6j1mboqikeh">
                      {faq.question}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-arc bg-arc text-white' : 'border-ink/20 text-ink'}`} aria-hidden data-id="element-167" data-mp="834jy8h39js5">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-168" data-mp="np954rsyo817" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-169" data-mp="xdr2ez217x03">
                  {isOpen && <motion.div id={`faq-panel-${index}`} role="region" aria-labelledby={`faq-trigger-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-170" data-mp="sfpkihgce3q7">
                      <p className="max-w-2xl pb-5 pr-12 text-[0.98rem] leading-relaxed text-graphite" data-id="element-171" data-mp="1p56zjn17t24k">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}